import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    width: '100%',
    display: 'flex',
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center',
    transition: '150ms',
    position: 'relative'
  },
  icon: {
    color: 'white',
    marginLeft: 16,
    fontSize: 16,
    position: 'absolute',
    left: 0
  },
  input: {
    border: 'none',
    outline: 'none',
    background: `${Color(COLORS.kgGreen).darken(0.09)}`,
    width: '100%',
    borderRadius: 3,
    padding: 16,
    paddingLeft: 48,
    fontSize: 14,
    color: COLORS.white,
    // border: `2px solid ${COLORS.kgGreen}`,
    '::placeholder': {
      color: 'rgba(255,255,255,0.64)'
    },
    '::selection': {
      color: COLORS.kgDarkGreen,
      background: '#fff',
    },
    ':hover': {
      background: `${Color(COLORS.kgGreen).darken(0.12)}`,
      // border: `2px solid ${Color(COLORS.kgGreen).lighten(0.04)}`
    },
    ':focus': {
      background: `${Color(COLORS.kgGreen).darken(0.12)}`,
      // border: `2px solid ${Color(COLORS.kgGreen).lighten(0.04)}`
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/layout/site-search-styles.js